import auth from "../../../shared/auth";
import { CANCEL_PAYMENT, FETCH_USER_PRICING_PLANS, PAUSE_PAYMENT, UNPAUSE_PAYMENT, UNCANCEL_PAYMENT, UPDATE_USER_ACCOUNT } from "./actions";

interface AccountState {
  loading: boolean;
  updating: boolean;
  account: any;
  pricingPlans: any[];
  pristine: boolean;
  redirect: any;
  initialPricingPlanType: number | null;
}

const defaultState: AccountState = {
  loading: false,
  updating: false,
  account: {},
  pricingPlans: [],
  pristine: true,
  redirect: null,
  initialPricingPlanType: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case "FETCH_ACCOUNT_PENDING": {
      return {
        ...state,
        errors: null,
        loading: true
      };
    }

    case "FETCH_ACCOUNT_FULFILLED": {
      return {
        ...state,
        account: action.payload.data,
        loading: false,
        redirect: null,
        initialPricingPlanType: action.payload.data.pricingPlanType
      };
    }

    case "FETCH_ACCOUNT_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case FETCH_USER_PRICING_PLANS + "_PENDING": {
      return {
        ...state,
        errors: null,
        loading: true
      };
    }

    case FETCH_USER_PRICING_PLANS + "_FULFILLED": {
      return {
        ...state,
        pricingPlans: action.payload.data.pricingPlans,
        loading: false
      };
    }

    case FETCH_USER_PRICING_PLANS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case "CHANGE_PRICING_PLAN": {
      return {
        ...state,
        account: { ...state.account, pricingPlanType: action.payload },
        pristine: false
      };
    }

    case UPDATE_USER_ACCOUNT + "_PENDING": {
      return {
        ...state,
        updating: true,
        errors: null
      };
    }

    case UPDATE_USER_ACCOUNT + "_FULFILLED": {
      let redirect: string | null = null;
      if (action.payload.data?.needToTakePayment) {
        const pricingPlanType = action.meta.account.pricingPlanType;
        redirect = `/payment/${pricingPlanType}`;
      }

      return {
        ...state,
        account: { ...action.meta.account, ...action.payload.data },
        updating: false,
        errors: null,
        pristine: true,
        redirect: redirect ? { to: redirect } : null,
        initialPricingPlanType: action.payload.data.pricingPlanType
      };
    }

    case UPDATE_USER_ACCOUNT + "_REJECTED": {
      return {
        ...state,
        account: action.meta.account,
        errors: action.payload.response.data.errors,
        updating: false
      };
    }

    case PAUSE_PAYMENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        updating: true
      };
    }

    case PAUSE_PAYMENT + "_FULFILLED": {
      return {
        ...state,
        account: { ...state.account, canPausePayment: false, canCancelPayment: false },
        updating: false
      };
    }

    case PAUSE_PAYMENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        updating: false
      };
    }

    case UNPAUSE_PAYMENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        updating: true
      };
    }

    case UNPAUSE_PAYMENT + "_FULFILLED": {
      return {
        ...state,
        account: { ...state.account, canPausePayment: true, canCancelPayment: true },
        updating: false
      };
    }

    case UNPAUSE_PAYMENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        updating: false
      };
    }

    case CANCEL_PAYMENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        updating: true
      };
    }

    case CANCEL_PAYMENT + "_FULFILLED": {
      return {
        ...state,
        account: { ...state.account, canPausePayment: false, canCancelPayment: false, willBeCancelled: true },
        updating: false
      };
    }

    case CANCEL_PAYMENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        updating: false
      };
    }

    case UNCANCEL_PAYMENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        updating: true
      };
    }

    case UNCANCEL_PAYMENT + "_FULFILLED": {
      return {
        ...state,
        account: { ...state.account, canPausePayment: true, canCancelPayment: true, willBeCancelled: false },
        updating: false
      };
    }

    case UNCANCEL_PAYMENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        updating: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
